import React, { KeyboardEvent } from 'react'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { Icon, IconChoices } from '../Icon'
import { downloadFile } from '../../../helpers/download'
import type { MediaGalleryItem } from './MediaGalleryModal'

interface MediaGalleryModalFooterProps {
  media: MediaGalleryItem | undefined
}

export const MediaGalleryModalFooter = ({
  media,
}: MediaGalleryModalFooterProps): JSX.Element => {
  const { translate } = useAppTranslation()

  const downloadImage = (): void => {
    if (media?.url) {
      downloadFile(media.url, media.id.slice(0, 7))
    }
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>): void => {
    if (e.key === 'Enter') {
      e.stopPropagation()
      downloadImage()
    }
  }

  return (
    <div
      className="flex gap-2"
      role="button"
      aria-label="Download"
      onClick={downloadImage}
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <p className="m-0">{translate('mediaGallery.downloadImageButtonText')}</p>
      <Icon icon={IconChoices.DOWNLOAD} highlighted />
    </div>
  )
}
